import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { LoggerService } from "src/service/logger.service";

@Component({
    selector: "app-popup-fast-checkin",
    templateUrl: "./popup-fast-checkin.component.html",
    styleUrls: ["./popup-fast-checkin.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupFastCheckinComponent implements OnInit, OnDestroy, iEvent {
  private _logContext: "Popup-fat-checkin.component";
  public _eventSubscriptions: Array<Subscription> = null;

  @Input() defaultRoom: number;

  constructor(
    private _modalController: ModalController,
    private _loggerService: LoggerService,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.subscribeEvents();
    this._loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "ngOnInit()",
      "START"
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Handle event for start card creation.
   * Dismiss modal during this operation
   */
  public async onCardCreationStart(): Promise<void> {
    await this._modalController.dismiss();
  }
}
